import { useState, type FormEvent } from "react";
import { Eye, EyeOff } from "lucide-react";
import { C, font } from "../theme";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { FieldInput } from "../components/Field";
import { Button } from "../components/Button";
import { useSession } from "../lib/session/SessionContext";

interface LoginScreenProps {
  onLoggedIn?: () => void;
}

export function LoginScreen({ onLoggedIn }: LoginScreenProps) {
  const { login, error } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLocalError(null);
    if (!email || !password) {
      setLocalError("Preencha e-mail e senha.");
      return;
    }
    setBusy(true);
    try {
      await login(email, password);
      onLoggedIn?.();
    } catch {
      // erro de sessão já exposto via `error` do contexto
    } finally {
      setBusy(false);
    }
  };

  const message = localError ?? error;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: font,
      }}
    >
      <ApogeuLogo width={170} />
      <div style={{ fontSize: 12, letterSpacing: 4, color: C.light, marginTop: 12, marginBottom: 32 }}>
        PERFORMANCE E GESTÃO
      </div>
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 320,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <label style={{ fontSize: 11, letterSpacing: 1, color: C.gray, fontWeight: 600 }}>
          EMAIL
          <FieldInput type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="voce@ct.com" style={{ marginTop: 4 }} />
        </label>
        <label style={{ fontSize: 11, letterSpacing: 1, color: C.gray, fontWeight: 600 }}>
          SENHA
          <div style={{ position: "relative", marginTop: 4 }}>
            <FieldInput
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{ paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(s => !s)}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              style={{
                position: "absolute",
                right: 6,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                padding: 6,
                cursor: "pointer",
                color: C.light,
                display: "flex",
              }}
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </label>
        {message && (
          <div style={{ fontSize: 12.5, color: C.red, background: "C.redSoft", borderRadius: 8, padding: "8px 12px" }}>
            {message}
          </div>
        )}
        <Button type="submit" disabled={busy} style={{ fontSize: 13, padding: "11px 14px" }}>
          {busy ? "Entrando..." : "Entrar"}
        </Button>
      </form>
    </div>
  );
}
